import { Card, CardBody, CardHeader, Col, Container, Input, Row, Table } from "reactstrap";
import { Btn, H4, H5, H6 } from "../../AbstractElements";
import { formatPhoneNumber, maskItem, URL_API } from "../../utils/helper/helpers"
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { formatDate, formatPrice, itemHasPermission } from "../../utils/helper/helpers";
import '../../utils/helper/style.css';
import { Link, useParams } from "react-router-dom";
import { PaiementClients } from "../../utils/helper/modal";

type Clients = { [key: string]: any }
interface Client { [key: string]: any; }
  
  interface Bon { [key: string]: any; }
  interface Vente { [key: string]: any; }
  
  interface Paiement { [key: string]: any; }
  
  interface Data {
    client: Client | null;
    bons: Bon[];
    vente: Vente[];
    paiement: Paiement[];
  }

const ShowClients = () => {

    const [filterText, setFilterText] = useState("");
    const [isLoading, setIsLoading] = useState<boolean>(true);
    // const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    // const [filteredItems, setFilteredItems] = useState<Clients[]>([]);
    const [data, setData] = useState<Data>({
        client: null,
        bons: [],
        vente: [],
        paiement: [],
      });
    const params = useParams();
    const [refresh, setRefresh] = useState(false);

    // modal
    const [modal, setModal] = useState(false);
    const [clientId, setClientId] = useState<number>();
    const [montantRestant, setMontantRestant] = useState<number>();
    const staticModalToggle = () => setModal(!modal);

    const openModal = (id: number, montant: number) => {
        setClientId(id);
        setMontantRestant(montant);
        setModal(true);
    };

    // Fetch data from API
    const fetchClients = useCallback(async () => {
        try {
            const Token = JSON.parse(localStorage.getItem("login")!);
            const response = await axios.get(`${URL_API}/client/get/${params.id}`, {
                headers: { Authorization: `Bearer ${Token}` }
            });
            if (response.data.success) {
                const { client, bons, vente, paiement } = response.data;
                setData({ client, bons, vente, paiement });
            }
        } catch (error: any) {
            const message = error.response?.data?.message || "Erreur inconnue";
            toast.error(message);
        }
    }, []);

    // Initial data fetch
    useEffect(() => {
        fetchClients();
        setIsLoading(false)
    }, [refresh, fetchClients]);

    const filtered = data.bons.filter(bon =>
        bon.nom_client?.toLowerCase().includes(filterText.toLowerCase()) ||
        bon.destination?.toLowerCase().includes(filterText.toLowerCase()) ||
        bon.num?.toLowerCase().includes(filterText.toLowerCase()) ||
        bon.immatriculation?.toLowerCase().includes(filterText.toLowerCase())
      );

      console.log(data);
let montant = 0;
    return (
        <div className='page-body'>
            {isLoading ? (
                <div className="loading-container">
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <span className="loading-text">Chargement de la plateforme...</span>
                    </div>
                </div>
            ) : ( 
                <>
                    <Breadcrumbs mainTitle="Details Clients" parent="Listes" />
                    <Container fluid>
                        <Row>
                            <Col md="12">
                                <Row>
                                    <Col sm="4">
                                        <Card className="progress-items pb-0 bg-light-info">
                                            <CardHeader className="pb-4 bg-light-info">
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <H5 className="mb-1">
                                                            <span className="text-dark">Nom : </span> <span className="text-dark fw-bold">{ data.client?.name }</span>
                                                        </H5>
                                                        <H5 className="mb-1">
                                                            <span className="text-dark">Tel : </span><span className="text-dark">{ formatPhoneNumber(data.client?.phone) }</span>
                                                        </H5>
                                                        <H5 className="mb-1">
                                                            <span className="text-dark">Adresse :</span> <span className="text-dark">{ formatPhoneNumber(data.client?.address) }</span>
                                                        </H5>
                                                        <H5 className="mt-1">
                                                            <span className="text-dark fw-bold">Details :</span> Ayant <span className="text-dark fw-bold">{ data.client?.nombre_bons + data.client?.nombre_approvisonnement }</span> Commande.s
                                                        </H5>
                                                    </div>
                                                    <div>
                                                        <i className="icofont icofont-users-alt-2 f-40"></i>
                                                    </div>
                                                </div>
                                            </CardHeader>
                                        </Card>
                                    </Col>
                                    <Col md="4">
                                        <p className="bg-light-dark p-3 rounded-top ">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <H5>
                                                        <span className="text-dark fw-bold">{maskItem(formatPrice(Number(data.client?.total_ventes) + Number(data.client?.montant_total)))}</span>
                                                    </H5>
                                                    <H6 className="text-white">
                                                        Montant Total
                                                    </H6>
                                                </div>
                                                <div>
                                                    <i className="icofont icofont-visa-electron f-40"></i>
                                                </div>
                                            </div>
                                        </p>
                                        <p className="bg-light-success p-3 rounded-bottom ">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <H5>
                                                        <span className="text-dark fw-bold">{maskItem(formatPrice(Number(data.client?.total_paiement)))}</span>
                                                    </H5>
                                                    <H6 className="text-white">
                                                        Montant Payé
                                                    </H6>
                                                </div>
                                                <div>
                                                    <i className="icofont icofont-visa-electron f-40"></i>
                                                </div>
                                            </div>
                                        </p>
                                    </Col>
                                    <Col md="4">
                                        <Card className="progress-items pb-0 bg-light-danger">
                                            <CardHeader className="bg-light-danger">
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <H4>
                                                            <span className="text-dark fw-bold">{ maskItem(formatPrice(Number(data.client?.total_ventes) + Number(data.client?.montant_total) - Number(data.client?.total_paiement))) }</span>
                                                        </H4>
                                                        <H6 className="f-20 f-w-600 mt-3">
                                                            Reste À Payer
                                                        </H6>
                                                    </div>
                                                    <div>
                                                        <i className="icofont icofont-bank-transfer f-80"></i>
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            {(itemHasPermission("super admin") || itemHasPermission('admin') || itemHasPermission('gest. versements ecriture') || itemHasPermission('gest. bons ecriture')) && (
                                                <Btn color="dark mt-2 w-100" onClick={() =>  openModal(data.client?.id, data.client?.total_ventes - data.client?.total_paiement)} className="btn btn-xs mx-1 p-1 px-3">
                                                    <i className="fa fa-money"></i> Effectuer le Paiement
                                                </Btn>
                                            )}
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm="12">
                                <Card className="invoice-card">
                                    <CardHeader className="pb-0">
                                        <H4 className="f-30 text-center"><i className="icofont icofont-money f-40 text-success"></i> Details Paiements <i className="icofont icofont-money f-40 text-success"></i></H4>
                                    </CardHeader>
                                    <CardBody className="invoice-table pt-0 checkbox-checked">
                                        <Table responsive id="all-invoice">
                                            <thead className="bg-info">
                                                <tr>
                                                    <th className="text-white text-center">No.</th>
                                                    <th className="text-white text-center">Montant</th>
                                                    <th className="text-white text-center">Descriptions</th>
                                                    <th className="text-white">Montant Payé</th>
                                                    <th className="text-white text-center">Montant Restant</th>
                                                    <th className="text-white text-center">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Première ligne */}
                                                {/* <tr>
                                                    <td className="text-center">####</td>
                                                    <td>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div className="flex-shrink-0">
                                                                <i className="icofont icofont-money-bag f-40 text-success"></i>
                                                            </div>
                                                            <div className="flex-grow-1">
                                                                <Link to="#">
                                                                    <H6 className="f-w-500">{maskItem(formatPrice(data.client?.total_ventes))}</H6>
                                                                </Link>
                                                                <span className="font-light text-capitalize f-w-400 f-13"> {formatDate(data.client?.created_at)} </span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="text-center"></td>
                                                    <td className="text-center bg-light-success">{formatPrice(0.00)}</td>
                                                    <td className="text-center bg-light-danger">{maskItem(formatPrice(data.client?.total_ventes))}</td>
                                                    <td className="text-center">
                                                    
                                                    </td>
                                                </tr> */}

                                                {/* Ligne des paiements */}
                                                {data.paiement && data.paiement.length > 0 ? (
                                                    data.paiement.map((item, index) => {
                                                        montant += Number(item.montant);
                                                        return (
                                                            <tr key={index}>
                                                                <td className="text-center">#{item.num_paiement}</td>
                                                                <td>
                                                                    {item.status === "Invalide" ? (
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div className="flex-shrink-0">
                                                                                <i className="icofont icofont-money-bag f-40 text-success"></i>
                                                                            </div>
                                                                            <div className="flex-grow-1">
                                                                                <Link to="#">
                                                                                    <H6 className="f-w-500">{formatPrice(item.montant)}</H6>
                                                                                </Link>
                                                                                <span className="text-success text-capitalize f-w-400 f-13"> Paiement Effectué </span>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <div className="flex-shrink-0">
                                                                                <i className="icofont icofont-money-bag f-40 text-success"></i>
                                                                            </div>
                                                                            <div className="flex-grow-1">
                                                                                <Link to="#">
                                                                                    <H6 className="f-w-500">{formatPrice(item.montant)}</H6>
                                                                                </Link>
                                                                                <span className="font-light text-capitalize f-w-400 f-13"> {formatDate(item.date_paiement)} </span>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <span className="fw-bold">{item.mode_de_paiement}</span> / {item.receveur}
                                                                </td>
                                                                <td className="text-center bg-light-success">
                                                                    {formatPrice(item.montant)}
                                                                </td>
                                                                <td className="text-center bg-light-danger">
                                                                    {formatPrice(Number(data.client?.total_ventes) - Number(montant))}
                                                                </td>
                                                                <td className="text-center">
                                                                    {item.justificatif == "" || item.justificatif == null ? (
                                                                        <span>Aucun Justificatif</span>
                                                                    ) : (
                                                                        <Btn
                                                                            color="light-info"
                                                                            // onClick={() =>
                                                                            //     downloadRecu(item.id, versements?.justificatif)
                                                                            // }
                                                                            className="btn btn-xs mx-1 p-1 px-3"
                                                                        >
                                                                            <i className="fa fa-download"></i> Télécharger
                                                                        </Btn>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={6} className="text-center">
                                                            Aucun paiement trouvé.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col sm="12">
                            <Row>
                                <Col md='6'>
                                
                                    <Card className="invoice-card">
                                        <H4 className="text-center my-2 f-30">Les Bons Attribués</H4>

                                        <CardBody className="invoice-table pt-0 checkbox-checked">
                                        <Input
                                            type="text"
                                            placeholder="Rechercher un numero de bon"
                                            value={filterText}
                                            onChange={e => setFilterText(e.target.value)}
                                            className="border p-2 rounded mb-4"
                                        />
                                            <Table responsive id="all-invoice">
                                                <thead className="bg-info">
                                                    <tr>
                                                        <th className="text-white ps-4">Num Bons</th>
                                                        <th className="text-white ">Vente</th>
                                                        <th className="text-white ">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filtered.map((item, index) => (

                                                        <tr key={index}>
                                                            <td>
                                                                {/* <div className="d-flex align-items-center gap-2"> */}

                                                                    <div className="flex-grow-1">
                                                                        <span className="text-capitalize f-w-800 f-13"> {item.num} </span> <br />
                                                                        <span>Dont {item.quantite_tonne} Tonnes</span>
                                                                    </div>
                                                                {/* </div> */}
                                                            </td>
                                                            <td className="bg-light-success">
                                                                <div className="flex-grow-1">
                                                                    <span className="text-capitalize f-w-800 f-13"> {formatPrice(item.montant_vente * item.quantite_tonne + item.transport)} </span> <br />
                                                                    <span>* {formatPrice(item.montant_vente)} + {formatPrice(item.transport)}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <Link to={`/show-bon-de-commande/${item.id}`} className='bg-dark btn btn-xs mx-1 my-1 for-light'>
                                                                    <i className='fa fa-eye'></i>
                                                                </Link>
                                                                <Btn className='btn bg-light-light btn-xs mx-1 my-1 for-dark'>
                                                                    <i className='fa fa-eye'></i>
                                                                </Btn>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>

                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md='6'>
                                {
                                    data.vente.length > 0 && (
                                        <Card className="invoice-card">
                                            <H4 className="text-center my-2 f-30">Les Achats du clients</H4>
                                            <CardBody className="invoice-table pt-0 checkbox-checked">
                                            <Input
                                                type="text"
                                                placeholder="Rechercher un numero de bon"
                                                value={filterText}
                                                onChange={e => setFilterText(e.target.value)}
                                                className="border p-2 rounded mb-4"
                                            />
                                                <Table responsive id="all-invoice" striped={true}>
                                                    <thead className="bg-info">
                                                        <tr>
                                                            <th className="text-white">Id</th>
                                                            {/* <th className="text-white ps-4">Clients / Téléphone</th> */}
                                                            <th className="text-white ">Prix / Nbr Produits</th>
                                                            <th className="text-white ">Date Approvisionnement</th>
                                                            <th className="text-white ">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data.vente.map((item, index) => (
                                                            <tr key={item.id}>
                                                                <th scope='row'>
                                                                    <span className="fw-bold">
                                                                        #{index + 1}
                                                                    </span>
                                                                </th>
                                                                <td>
                                                                    <span className="fw-bold text-capitalize">
                                                                        {maskItem(formatPrice(item.vente_total))}
                                
                                                                    </span><br />
                                                                    <span>
                                                                        {parseInt(item.produit_count).toLocaleString("gn-GN")} Produit.s
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span className="fw-bold text-capitalize">
                                                                        {formatDate(item.date_vente)}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <Link to={`${process.env.PUBLIC_URL}/vente-facture/${item.id}`} className='bg-dark btn btn-xs mx-1 my-1'>
                                                                        <i className='fa fa-eye'></i>
                                                                    </Link>
                                                                    {/* <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'supprimer' })}>
                                                                        <i className='fa fa-trash'></i>
                                                                    </Btn> */}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>

                                            </CardBody>
                                        </Card>
                                    )
                                }
                                </Col>
                            </Row>

                                
                                
                            </Col>
                            
                        </Row>
                        
                    </Container>
                </>
            )}
            {
                PaiementClients({
                    isOpen: modal,
                    montant: montantRestant ?? 0,
                    client_id: clientId ?? 0,
                    toggle: staticModalToggle,
                }, () => setRefresh(!refresh))
            }
        </div >

    )
}

export default ShowClients
